import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed.ts';

const DigitalOperations = {
  Helmet: lazy(() => import('./components/Helmet.tsx')),
  QualityAssurance: lazyNamed(() => import('./containers/QualityAssurance/index.tsx'), 'QualityAssurance'),
  CampaignManagement: lazy(() => import('./containers/CampaignManagement/index.tsx')),
  CampaignManagement2: lazyNamed(() => import('./containers/CampaignManagement2/index.tsx'), 'CampaignManagement2'),

  Approval: {
    CreativesList: lazy(() => import('./containers/Approval/containers/CreativesList/index.tsx')),
    CreativeDraftsPage: lazy(() => import('./containers/Approval/containers/CreativeDraftsPage/index.ts')),
    Layout: lazy(() => import('./containers/Approval/components/Layout.tsx')),
  },

  ApprovalV2: {
    Layout: lazyNamed(() => import('./containers/ApprovalV2/index.tsx'), 'ApprovalV2'),
    CreativesList: lazyNamed(() => import('./containers/ApprovalV2/containers/CreativesList/index.tsx'), 'CreativesList'),
    CrawlerArticles: lazyNamed(() => import('./containers/ApprovalV2/containers/CrawlerArticles/index.tsx'), 'CrawlerArticles'),
  },

  ScreenshotManagement: {
    Campaigns: lazy(() => import('./containers/ScreenshotManagement/containers/Campaigns/index.tsx')),
    Approvals: lazy(() => import('./containers/ScreenshotManagement/containers/Approvals/index.tsx')),
    Done: lazy(() => import('./containers/ScreenshotManagement/containers/Done/index.tsx')),
    Hidden: lazy(() => import('./containers/ScreenshotManagement/containers/Hidden/index.tsx')),
    Layout: lazy(() => import('./containers/ScreenshotManagement/components/Layout.tsx')),
  },
};

export { ApprovalStatus, DigitalOperationStatus } from './types.ts';

export default DigitalOperations;
